import React from "react";
import { Wrapper, Title, Sorriso, ContainerButton } from "./style";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import Steps from "./Steps";
import { CustomButtom } from '../../../../components/BotaoCTA/styles';
import { eventTrack } from 'src/components/GoogleTagManager';
import { slugfy } from 'src/utils/formatters';
import { colorBrandPrimary } from "src/global.style";

export default function ComeceAgora() {
  const { data, isLoading } = useFetchContent();
  if (isLoading || !data) return <Loading />;

  const scrollToOffer = () => {
    const el = document.querySelector('#plans');
    const yOffset = -80;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  };
  const { title, backgroundColor } = getSection({
    sectionName: "landingStepperSection",
    data,
  });
  const botao = 'Criar conta'
  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Title tamanho="Médio">{title}</Title>
      <Sorriso filter={false} />
      <Steps />
      <ContainerButton>
        <CustomButtom
          className="botaoTagVeloe"
          color="primary"
          label={botao}
          onClick={() => {
            scrollToOffer();
            eventTrack(
              'veloe:institucional',
              'clique:botao',
              'tag-veloe:' + slugfy(botao)
            );
          }}
          style={{
            backgroundColor: `${colorBrandPrimary.blue}`,
            color: "#ffffff"
          }}
        />
      </ContainerButton>
    </Wrapper>
  );
}
